enum MediaActionSelectionLabels {
    CopyUrl = 'Copy URL',
    Edit = 'Edit',
    PreviewAudio = 'Preview',
    PreviewDocument = 'Preview',
    PreviewVideo = 'Preview',
}

export default MediaActionSelectionLabels;
